import React, { Component } from 'react';
import { SmallButton } from "./common/Buttons";
import { ChooseMethod } from "./common/ChooseMethod";
import styled from 'styled-components';
import mfaTokenImg from "../images/mfa-app-token.png";
import { t } from "./helper/ClientAppLocalizer";

const StyledInput = styled.input`
  margin-top: 20px;
  width:320px;
`

export class AuthyToken extends Component {
    static displayName = AuthyToken.name;

    constructor(props) {
        super(props);
        this.state = {
            token: "",
            isLoginEnabed: false
        };

        this.verifyCode = this.verifyCode.bind(this);
        this.setToken = this.setToken.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidMount() {
        
    }

    verifyCode() {
        const txtIncorrectCodeTryAgain = t("Authy.IncorrectCodeTryAgain");

        fetch('/api/MFA/verifyAuthyToken/' + this.state.token, { method: 'post' })
            .then(results => {
                if (results.status === 200) {
                    return results.json();
                }
                else {
                    throw new Error(results.statusText);
                }

            }).then(data => {
                if (data.success) {
                    this.setState({ errorMessage: "" });
                    this.props.verificationComplete(data);
                } else {
                    this.setState({ errorMessage: txtIncorrectCodeTryAgain });
                    this.props.allowRetry(data.allowRetry, txtIncorrectCodeTryAgain, data.returnUrl);
                }          
            }).catch(error => {
                //"Error Verifying Authy Token");
                this.setState({ error: true });
            });
    }

    setToken(e) {
        this.setState({ token: e.target.value });
        this.setState({ isLoginEnabed: e.target.value.length >= 4 })
    }

    onKeyDown(e)
    {
        if(e.keyCode === 13) {
            this.verifyCode();
        }
    }

    render() {
        const enterTokenTxt = t("Authy.EnterTokenFromAuthyApp");
        const openAuthyTxt = t("Authy.OpenAuthyApp");
        const enter7DigitTxt = t("Authy.Enter7DigitCode");
        const warn = t("SystemMessages.CommonWarning");
        return (
            <div id="contentToken">
                <img id="topImage" alt="Ceridian Logo" src={mfaTokenImg} style={{maxHeight:120, maxWidth:120, alignContent: 'center'}}/>
                <h4 className="mfa-header">{enterTokenTxt}</h4>
                <p className="mfa-text">{openAuthyTxt}</p>
                <p className="mfa-text" style={{ color: "black", fontWeight: "bold" }}>{warn}</p>
                <p className="mfa-text">{enter7DigitTxt}</p>
                <div>
                    <StyledInput id="authyTotpCode" type="text" onChange={this.setToken} onKeyDown={this.onKeyDown} maxLength="10"/>
                </div>
                {this.state.errorMessage ? <div className="mfa-text" style={{ marginBottom: 10, color: 'red', fontSize: '70%' }}>{this.state.errorMessage}</div> : ''}
                <div style={{ marginTop: "20px" }}>
                    <SmallButton id="authyTotpSubmit" onClick={this.verifyCode} disabled={!this.state.isLoginEnabed}>{t("Login")}</SmallButton>
                </div>
                <ChooseMethod changeVerificationMethod={this.props.changeVerificationMethod} lockoutMessage={this.props.lockoutMessage}/>
            </div>
        );
    }
}